function OfficeIndexController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	var CLASS_OPEN = 'is-open';
	
	
	/* PRIVATE VARIABLES */
	var tiles = null;
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}
	
	
	/*
	 * Pointer devices reveal on hover, touch devices on tap.
	 * Binding only one of the two keeps iOS from leaving a tapped tile
	 * stuck in the hover state.
	 */
	function initTiles(){
		tiles = $('.office-tile', _this.container);
		if(!tiles.length){
			return;
		}
		
		if(window.matchMedia && window.matchMedia('(hover: hover)').matches){
			tiles.on('mouseenter', function(){
				openTile($(this));
			});
			tiles.on('mouseleave', function(){
				closeTiles();
			});
		} else {
			tiles.on('click', function(e){
				// let the contact links work once the tile is open
				if($(e.target).closest('a').length){
					return;
				}
				e.preventDefault();
				var tile = $(this);
				if(tile.hasClass(CLASS_OPEN)){
					closeTiles();
				} else {
					openTile(tile);
				}
			});
			
			// tap outside closes
			$(document).on('click', function(e){
				if(!$(e.target).closest('.office-tile').length){
					closeTiles();
				}
			});
		}
	}
	
	
	function openTile(tile){
		tiles.not(tile).removeClass(CLASS_OPEN);
		tile.addClass(CLASS_OPEN);
	}
	
	
	function closeTiles(){
		tiles.removeClass(CLASS_OPEN);
	}
	
   
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			// object references
			
			// init
			initTiles();

			_this.inited = true;
		}
	};
		

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
